/**
 * Mock Delivery Data
 * 10 sample deliveries spanning across 7 days
 */

import type { DeliveryEntry } from '../types'

// Get dates for the past 7 days
const today = new Date()
const getDateDaysAgo = (days: number): Date => {
  const date = new Date(today)
  date.setDate(date.getDate() - days)
  return date
}

// Mock delivery data
export const mockDeliveries: DeliveryEntry[] = [
  // Day 0 (Today) - 2 deliveries
  {
    id: 'mock-del-001',
    driverId: 'driver-001',
    timestamp: new Date().toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzRBOTBFMiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICMxPC90ZXh0Pjwvc3ZnPg==',
    note: 'Package delivered to front porch',
    location: {
      latitude: 40.7128,
      longitude: -74.0060,
      accuracy: 10,
      timestamp: new Date().toISOString()
    },
    status: 'delivered'
  },
  {
    id: 'mock-del-002',
    driverId: 'driver-001',
    timestamp: new Date(today.getTime() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzUyQzQxQSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICMyPC90ZXh0Pjwvc3ZnPg==',
    note: 'Left with neighbor at apartment 2B',
    location: {
      latitude: 40.7589,
      longitude: -73.9851,
      accuracy: 8,
      timestamp: new Date(today.getTime() - 2 * 60 * 60 * 1000).toISOString()
    },
    status: 'synced'
  },
  
  // Day 1 (Yesterday) - 2 deliveries
  {
    id: 'mock-del-003',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(1).setHours(14, 30)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0ZGOUIzMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICMzPC90ZXh0Pjwvc3ZnPg==',
    note: 'Signed by customer - John Smith',
    location: {
      latitude: 40.7614,
      longitude: -73.9776,
      accuracy: 12,
      timestamp: new Date(getDateDaysAgo(1).setHours(14, 30)).toISOString()
    },
    status: 'synced'
  },
  {
    id: 'mock-del-004',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(1).setHours(10, 15)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0U5MUM3QSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICM0PC90ZXh0Pjwvc3ZnPg==',
    note: 'Package left in mailroom',
    location: {
      latitude: 40.7480,
      longitude: -73.9862,
      accuracy: 15,
      timestamp: new Date(getDateDaysAgo(1).setHours(10, 15)).toISOString()
    },
    status: 'synced'
  },
  
  // Day 2 (2 days ago) - 1 delivery
  {
    id: 'mock-del-005',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(2).setHours(15, 45)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzhCNUNGNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICM1PC90ZXh0Pjwvc3ZnPg==',
    note: 'Delivered to receptionist at office building',
    location: {
      latitude: 40.7549,
      longitude: -73.9840,
      accuracy: 9,
      timestamp: new Date(getDateDaysAgo(2).setHours(15, 45)).toISOString()
    },
    status: 'synced'
  },
  
  // Day 3 (3 days ago) - 2 deliveries
  {
    id: 'mock-del-006',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(3).setHours(16, 20)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0ZGNTc1NyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICM2PC90ZXh0Pjwvc3ZnPg==',
    note: 'Left at back door per customer request',
    location: {
      latitude: 40.7306,
      longitude: -73.9352,
      accuracy: 11,
      timestamp: new Date(getDateDaysAgo(3).setHours(16, 20)).toISOString()
    },
    status: 'synced'
  },
  {
    id: 'mock-del-007',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(3).setHours(11, 10)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzM0RDBENTQ1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjAiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+RGVsaXZlcnkgIzc8L3RleHQ+PC9zdmc+',
    note: 'Package handed directly to customer',
    location: {
      latitude: 40.7282,
      longitude: -73.7949,
      accuracy: 7,
      timestamp: new Date(getDateDaysAgo(3).setHours(11, 10)).toISOString()
    },
    status: 'synced'
  },
  
  // Day 4 (4 days ago) - 1 delivery
  {
    id: 'mock-del-008',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(4).setHours(13, 0)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI0ZGQzkwMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICM4PC90ZXh0Pjwvc3ZnPg==',
    note: 'Delivery to storage unit facility',
    location: {
      latitude: 40.7580,
      longitude: -73.9855,
      accuracy: 13,
      timestamp: new Date(getDateDaysAgo(4).setHours(13, 0)).toISOString()
    },
    status: 'synced'
  },
  
  // Day 5 (5 days ago) - 1 delivery
  {
    id: 'mock-del-009',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(5).setHours(9, 30)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzAwQkNENCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICM5PC90ZXh0Pjwvc3ZnPg==',
    note: 'Left package at side entrance',
    location: {
      latitude: 40.7411,
      longitude: -73.9897,
      accuracy: 14,
      timestamp: new Date(getDateDaysAgo(5).setHours(9, 30)).toISOString()
    },
    status: 'synced'
  },
  
  // Day 6 (6 days ago) - 1 delivery
  {
    id: 'mock-del-010',
    driverId: 'driver-001',
    timestamp: new Date(getDateDaysAgo(6).setHours(14, 50)).toISOString(),
    photo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzlDMjdCMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjIwIiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRlbGl2ZXJ5ICMxMDwvdGV4dD48L3N2Zz4=',
    note: 'Package delivered to front desk - signature obtained',
    location: {
      latitude: 40.7489,
      longitude: -73.9680,
      accuracy: 10,
      timestamp: new Date(getDateDaysAgo(6).setHours(14, 50)).toISOString()
    },
    status: 'synced'
  }
]
